module.exports = __webpack_public_path__ + "img/function.c91d7938.svg";